//#region Styles
import FileIcon from "icons/FileIcon";
import { 
    Container, 
    DataSection } from "./styles";
//#endregion

const DataField = ({
    quantityRows, 
    file
}) => {
    const withEs = () => quantityRows !== 1 ? "s" : "";
    return (
        <Container>
            <DataSection>
                <h5>Registro:</h5>
                <span>
                    {quantityRows} registro{withEs()} cargado{withEs()}
                </span>
            </DataSection>
            <DataSection>
                <h5>Archivo adjunto:</h5>
                <div>
                    <FileIcon/>
                    <a href={file.url} download={file.name}>{file.name}</a>
                </div>
            </DataSection>
        </Container>
    );
}

export default DataField;